import { render, staticRenderFns } from "./copyrightfooter.vue?vue&type=template&id=609b5bb7&scoped=true&"
import script from "./copyrightfooter.vue?vue&type=script&lang=js&"
export * from "./copyrightfooter.vue?vue&type=script&lang=js&"
import style0 from "./copyrightfooter.vue?vue&type=style&index=0&id=609b5bb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b5bb7",
  null
  
)

export default component.exports